{
  "CSAT": {
    "TITLE": "Valuta la conversazione",
    "PLACEHOLDER": "Dicci di più...",
    "RATINGS": {
      "POOR": "😞 Scarso",
      "FAIR": "😑 Discreto",
      "AVERAGE": "😐 Nella media",
      "GOOD": "😀 Buono",
      "EXCELLENT": "😍 Eccellente"
    }
  }
}
